import { GET } from './Httpr.js';



export async function getModulesByCourseId(request){
    let url = 'modules/getAll';
    let requestData = {
        id_course:request,
        name:""
    };

    let rsp = await GET(url, requestData);

    return rsp;
}